import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme, Container } from '@mui/material';
import Nav from './components/Nav';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import RefillHistory from './pages/RefillHistory';
import Settings from './pages/Settings';
const theme = createTheme();
export default function App() {
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsxs(BrowserRouter, { children: [_jsx(Nav, {}), _jsx(Container, { component: "main", maxWidth: "md", sx: { pt: { xs: 2, sm: 2 }, pb: { xs: 8, sm: 2 } }, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "/inventory", element: _jsx(Inventory, {}) }), _jsx(Route, { path: "/refill-history", element: _jsx(RefillHistory, {}) }), _jsx(Route, { path: "/settings", element: _jsx(Settings, {}) })] }) })] })] }));
}
